<template>
  <b-row class="stats">
    <b-col  v-for="(stats, index) in data" v-bind:key="index">
      <span>{{ stats.title }}</span>
      <span :style="{color: stats.color}">{{ stats.value }}</span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Stats',
  props: ['data']
}
</script>
<style scoped>
.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem;
  width: 100%;
}

.stats>div{
  display: grid;
  justify-content: start;
  text-align: start;
  height: 5rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(0.625rem - 2px);
  padding: 1rem 1rem;
  color: #000000a6;
}

.stats>div>span:last-of-type{
  font-weight: bold;
}
</style>
